<template>
  <div style="display: inline-block;vertical-align: middle;">
    <span v-show="!selectCar" :class="[ types === 0 ? 'permanent' : 'temporary','licenseplate',isSelect?'select-car':'']" @click="clickLicenseplate"> 
      <span>{{licensepalte}}</span> <br />
      <span>{{area}}</span>
    </span>
    <span v-show="selectCar" :class="['permanent' ,'licenseplate','select-car','defaults']" @click="clickLicenseplate"> 
      <span class="click-select">{{$t('public.checkCarSelect')}}</span>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'vueLicenseplate',
    props: {
      licensepalte: {
        type: String,
        default: ''
      },
      area: {
        type: String,
        default: ''
      },
      types: {
        type: Number,
        default: 0
      },
      isSelect: {
        type: Boolean,
        default: false
      },
      selectCar: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      clickLicenseplate(){
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss" scoped>
.licenseplate{
  display: inline-block;
  border: 2px solid #515c60;
  border-radius: 8px;
  padding: 8px 0;
  width: 126px;
  height: 50px;
  text-align: center;
  vertical-align: middle;
  line-height: normal;
  // background: url(../../assets/liscenplate-white.png) no-repeat center;
  background-size: contain;
  
  // 临时
  &.temporary{
    // background: url(../../assets/liscenplate-red.png) no-repeat center;
    background: red;
    background-size: contain;
  }
  
  span{
    color: #000;
    font-weight: bold;
    &:first-child{
      font-size: 14px !important;
    }
  }
  .click-select{
    color: #a9a9a9 !important;
  }
}
.select-car{
  cursor: pointer;
}
.defaults{
  line-height: 30px;
}
</style>